    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js?v=3.5.0', { scope: '/' })
                .catch((error) => console.error('Cosmo Crypt Service Worker registration failed:', error));
        });
    }
